import { baseApi } from "../api";
import {
  CustomRangeReportArgs,
  CustomRangeReportResponse,
  TaxYearReportArgs,
  TaxYearReportResponse,
} from "./types";

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomRangeReport: builder.query<
      CustomRangeReportResponse,
      CustomRangeReportArgs
    >({
      query: ({ startDate, endDate }) => ({
        url: "/reports/custom",
        params: { startDate, endDate },
      }),
      providesTags: ["Report"],
    }),

    getTaxYearReport: builder.query<TaxYearReportResponse, TaxYearReportArgs>({
      query: ({ taxYear }) => ({
        url: "/reports/tax-year",
        params: { taxYear },
      }),
      providesTags: ["Report"],
    }),
  }),
});

export const {
  useLazyGetCustomRangeReportQuery,
  useLazyGetTaxYearReportQuery,
} = reportsApi;
